export default function () {
  // if we are on portal.x.dev.nelson.services, strip to x.dev.nelson.services
  return (
    process.env.REACT_APP_API_HOST ||
    window.location.protocol + "//" + window.location.hostname.replace("portal.", "")
  );
}
